"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Body = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Body = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1;\n    overflow: hidden auto;\n    height: calc(100vh - 40px);\n    font-family: ", ";\n    font-size: 1rem;\n\n    .ory-cell-droppable {\n        position: relative;\n\n        &.ory-cell-droppable-is-over-left-of,\n        &.ory-cell-droppable-is-over-right-of {\n            overflow: hidden;\n        }\n    }\n\n    .ory-cell-draggable {\n        .component-border {\n            border-width: 1px;\n            border-style: dashed;\n        }\n    }\n\n    .ory-cell-focused {\n        box-shadow: 0 0 0 1px hotpink;\n    }\n\n    /* Fix for Chrome not deleting cells with iframes \n   when the iframe overlays the delete icon */\n    .ory-cell-draggable-is-dragging {\n        iframe {\n            display: none;\n        }\n\n        .embed-iframe iframe {\n            display: block;\n        }\n    }\n\n    .component-wrapper {\n        &:hover {\n            > .component-border {\n                border-width: 1px;\n                border-style: dashed;\n            }\n        }\n    }\n"])), function (props) {
  var _props$theme, _props$theme$fonts;

  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$fonts = _props$theme.fonts) === null || _props$theme$fonts === void 0 ? void 0 : _props$theme$fonts.body;
});

exports.Body = Body;